import { Icon } from "@iconify/react/dist/iconify.js";
import axios from "axios";
import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Snackbar, Alert, CircularProgress } from "@mui/material";
import moment from "moment";

function toLocalDatetimeInputValue(utcString) {
  if (!utcString) return "";
  const date = new Date(utcString);
  const pad = (n) => n.toString().padStart(2, "0");
  const yyyy = date.getFullYear();
  const MM = pad(date.getMonth() + 1);
  const dd = pad(date.getDate());
  const hh = pad(date.getHours());
  const mm = pad(date.getMinutes());
  return `${yyyy}-${MM}-${dd}T${hh}:${mm}`;
}

const EditZoomMeeting = () => {

  const [formValues, setFormValues] = useState({
    batch_id: "",
    dateNTime: "",
    link: "",
    title:"",
  });

  const location = useLocation();
  const zoomToEdit = location.state?.zoom;

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [batches, setBatches] = useState([]);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [touched, setTouched] = useState(false);
  const [roles, setRoles] = useState([]);
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarSeverity, setSnackbarSeverity] = useState("success");
  const navigate = useNavigate();
  useEffect(() => {
    if (zoomToEdit) {
      console.log("Zoom info: ", zoomToEdit);

      setFormValues({
        batch_id: zoomToEdit?.batchData?._id,
        dateNTime: zoomToEdit?.dateNTime,
        link: zoomToEdit?.link,
        title: zoomToEdit?.title,
      });
      setLoading(false); // Stop loading after setting form state
    } else {
      setError("No zoom data found.");
      setLoading(false);
    }
  }, [zoomToEdit]);

  useEffect(() => {
    const fetchBatches = async () => {
      try {
        const token = localStorage.getItem("token");
        if (!token) {
          // console.log("Access required");
          return;
        }
        const response = await axios.get(
          `${process.env.REACT_APP_INSTITUTION_BASEURL}/get-all-batches`,
          {
            headers: { Authorization: `Bearer ${token}` },
          }
        );
        const ongoingBatches = response?.data?.data?.ongoing;
        if (Array.isArray(ongoingBatches)) {
          setBatches(ongoingBatches);
        } else {
          setBatches([]);
        }        // console.log(response?.data?.data);
      } catch (error) {
        // console.log(error);
      }
    };
    fetchBatches();
  }, []);


  const handleCloseSnackbar = () => {
    setOpenSnackbar(false);
  };

  const handleFormSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const token = localStorage.getItem("token");
      if (!token) {
        // console.log("Access required");
        return;
      }

      // console.log(
      //   "REACT_APP_INSTITUTION_BASEURL:: ",
      //   process.env.REACT_APP_INSTITUTION_BASEURL
      // );
      const response = await axios.put(
        `${process.env.REACT_APP_INSTITUTION_BASEURL}/edit-zoom-meetings/${zoomToEdit._id}`,
        formValues,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      if (response.status === 200) {
        setSnackbarMessage("Updated successfully!");
        setSnackbarSeverity("success");
        setOpenSnackbar(true);
        setTimeout(() => {
          navigate("/zoom-list");
        }, 2000);
      }
    } catch (err) {
      setLoading(false);

      // Check for 400 status error
      if (err.response && err.response.status === 400) {
        setSnackbarMessage("Please fill out all required fields...");
        setSnackbarSeverity("warning");
        setOpenSnackbar(true);
      } else {
        setSnackbarMessage(
          "Failed to update. Please try again"
        );
        setSnackbarSeverity("error");
        setOpenSnackbar(true);
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="row gy-4">
      <div className="col-lg-8" style={styles.cardContent(loading)}>
        <div className="card h-100">
          <div className="card-body p-24">
            <form onSubmit={handleFormSubmit}>
            <div className="mb-20">
                <label
                  htmlFor="title"
                  className="form-label fw-semibold text-primary-light text-sm mb-8"
                >
                  Title<span className="text-danger-600">*</span>
                </label>
                <input
                  type="text"
                  className="form-control radius-8"
                  id="title"
                  required
                  placeholder="Enter Title"
                  value={formValues.title}
                  onChange={(e) => {
                    const value = e.target.value;
                    if (value === "" || value.trim() !== "") {
                      setFormValues({
                        ...formValues,
                        title: e.target.value,
                      });
                    }
                  }}

                />
              </div>
            <div className="mb-20">
                <label
                  htmlFor="batch"
                  className="form-label fw-semibold text-primary-light text-sm mb-8"
                >
                  Batch
                  <span className="text-danger-600">*</span>
                </label>
                <select
                  className="form-control radius-8 form-select"
                  id="batch"
                  required
                  value={formValues.batch_id}
                  onChange={(e) =>
                    setFormValues({
                      ...formValues,
                      batch_id: e.target.value,
                    })
                  }
                >
                  <option value="" disabled>
                    Select a Batch
                  </option>
                  {batches.map((batch) => (
                    <option key={batch._id} value={batch._id}>
                      {batch.batch_name}
                    </option>
                  ))}
                </select>
              </div>
              
              <div className="mb-20">
                <label
                  htmlFor="dateNTime"
                  className="form-label fw-semibold text-primary-light text-sm mb-8"
                >
                  Date and Time {"   "} {formValues.dateNTime ? new Date(formValues.dateNTime).toLocaleString() : ""}
                  <span className="text-danger-600">*</span>
                </label>
                <input
                  type="datetime-local"
                  className="form-control radius-8"
                  id="dateNTime"
                  required
                  placeholder="Enter date"
                  value={moment(formValues.dateNTime).format('YYYY-MM-DDTHH:mm:ss')}
                  onChange={(e) => {

                    const value = moment(e.target.value).format('YYYY-MM-DDTHH:mm:ss.SSSZ');

                    if (value === "" || value.trim() !== "") {
                      setFormValues({
                        ...formValues,
                        dateNTime: value,
                      });
                    }
                  }}
                  onBlur={() => setTouched(true)} // Mark as touched when losing focus
                />
              </div>

              <div className="mb-20">
                <label
                  htmlFor="link"
                  className="form-label fw-semibold text-primary-light text-sm mb-8"
                >
                  Link<span className="text-danger-600">*</span>
                </label>
                <input
                  type="text"
                  className="form-control radius-8"
                  id="link"
                  required
                  placeholder="Enter Link"
                  value={formValues.link}
                  onChange={(e) => {
                    const value = e.target.value;
                    if (value === "" || value.trim() !== "") {
                      setFormValues({
                        ...formValues,
                        link: e.target.value,
                      });
                    }
                  }}

                />
              </div>
             

              <div className="d-flex align-items-center justify-content-center gap-3">
                <button
                  type="button"
                  className="border border-danger-600 bg-hover-danger-200 text-danger-600 text-md px-56 py-11 radius-8"
                  onClick={() => navigate("/zoom-list")}
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  className="btn btn-primary border border-primary-600 text-md px-56 py-12 radius-8"
                // onClick={handleFormSubmit}
                >
                  {loading && (
                    <div
                      className="loader-container"
                      style={styles.loaderContainer}
                    >
                      <CircularProgress />
                    </div>
                  )}
                  Save
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
      {/* snackbar */}
      <Snackbar
        open={openSnackbar}
        autoHideDuration={3000}
        onClose={handleCloseSnackbar}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
      >
        <Alert
          onClose={handleCloseSnackbar}
          severity={snackbarSeverity}
        // variant="filled"
        // sx={{ width: '100%' }}
        >
          {snackbarMessage}
        </Alert>
      </Snackbar>
    </div>
  );
};

// Add CSS for loader
const styles = {
  loaderContainer: {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    zIndex: 1000,
  },
  cardContent: (loading) => ({
    opacity: loading ? 0.5 : 1,
  }),
};

export default EditZoomMeeting;
